import React from "react";
import { Divider } from "antd";

const CustomDropdownRender = ({ menu, onToggleAll }) => (
  <div>
    {menu}
    <Divider style={{ margin: "4px 0" }} />
    <div
      style={{
        padding: "8px",
        cursor: "pointer",
        color: "#1d5e5c",
        textAlign: "center",
        position: "sticky",
        bottom: 0,
        background: "#fff",
        zIndex: 1,
      }}
      onClick={onToggleAll}
    >
      Select/Deselect ALL
    </div>
  </div>
);

export default CustomDropdownRender;
